import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import KaroIcon from "@/components/Icons/KaroIcon";
import KupaIcon from "@/components/Icons/KupaIcon";
import MacaIcon from "@/components/Icons/MacaIcon";
import SinekIcon from "@/components/Icons/SinekIcon";
import { Table as AntTable, Space, Typography } from "antd";
import { Badge, Cards, Container, PlayerName, PlayerNumber, Text } from "./OnlinePlayersInfoCard.style";
var Link = Typography.Link;
var OnlinePlayersInfoCard = function (_a) {
    var _b, _c;
    var data = _a.data, t = _a.t;
    var columns = [
        {
            title: t("Player"),
            dataIndex: "player",
            key: "player",
            width: "22%",
            render: function (player, record) { return (_jsxs(Space, { children: [_jsx(PlayerNumber, { isActive: record.isActive, children: record.number }), player ? (_jsx(PlayerName, { isActive: record.isActive, children: _jsx(Link, { children: player }) })) : (_jsx(PlayerName, { isActive: record.isActive, children: t("Empty") }))] })); },
        },
        {
            title: t("Chips"),
            dataIndex: "chips",
            key: "chips",
            width: "15%",
            render: function (chips) { return (chips ? _jsx(Text, { type: "chips", children: chips }) : _jsx(Text, { type: "secondary", children: "-" })); },
        },
        {
            title: t("Bet Amount"),
            dataIndex: "betAmount",
            key: "betAmount",
            width: "15%",
            render: function (amount) { return (amount ? _jsx(Text, { type: "betAmount", children: amount }) : _jsx(Text, { type: "secondary", children: "-" })); },
        },
        {
            title: t("Possible Actions"),
            dataIndex: "actions",
            key: "actions",
            width: "20%",
            render: function (actions) { return (actions ? _jsx(Text, { type: "actions", children: actions.map(function (action) { return (action.startsWith("PLAYER_") ? action.replace(/^PLAYER_/, "") : action); }).join(", ") }) : _jsx(Text, { type: "secondary", children: "-" })); },
        },
        {
            title: t("Last Action"),
            dataIndex: "lastAction",
            key: "lastAction",
            width: "15%",
            render: function (action) { return (action && action.action ? _jsx(Badge, { action: action.action, children: action.action.startsWith("PLAYER_") ? action.action.replace(/^PLAYER_/, "") : action.action }) : _jsx(Text, { type: "secondary", children: "-" })); },
        },
        {
            title: t("Cards"),
            dataIndex: "cards",
            key: "cards",
            width: "15%",
            render: function (cards) {
                return cards ? (_jsx(Space, { size: "small", children: cards.map(function (card, index) { return (_jsxs(Cards, { hasOpacity: card.hasOpacity, isRed: card.cardIconName === "Kupa" || card.cardIconName === "Karo", children: [_jsx("span", { children: card.cardIcon }), _jsx("span", { children: card.cardNumber })] }, index)); }) })) : (_jsx(Text, { type: "secondary", children: "-" }));
            },
        },
    ];
    var dataSource = (_c = (_b = data === null || data === void 0 ? void 0 : data.activeGame) === null || _b === void 0 ? void 0 : _b.seats) === null || _c === void 0 ? void 0 : _c.map(function (seat, index) {
        var _a, _b, _c, _d;
        return {
            key: index,
            number: index + 1,
            player: ((_a = seat.player) === null || _a === void 0 ? void 0 : _a.nickname) || null,
            chips: seat.chips || null,
            betAmount: seat.betAmount || null,
            actions: ((_b = seat.actions) === null || _b === void 0 ? void 0 : _b.possible) || null,
            lastAction: ((_c = seat.actions) === null || _c === void 0 ? void 0 : _c.last) || null,
            cards: ((_d = seat.cards) === null || _d === void 0 ? void 0 : _d.map(function (card) {
                var suit = card.slice(-1);
                var value = card.slice(0, -1);
                var cardIcon = null;
                var cardIconName = "";
                switch (suit) {
                    case "H":
                        cardIcon = _jsx(KupaIcon, {});
                        cardIconName = "Kupa";
                        break;
                    case "D":
                        cardIcon = _jsx(KaroIcon, {});
                        cardIconName = "Karo";
                        break;
                    case "S":
                        cardIcon = _jsx(MacaIcon, {});
                        cardIconName = "Sinek";
                        break;
                    case "C":
                        cardIcon = _jsx(SinekIcon, {});
                        cardIconName = "Maca";
                        break;
                }
                return { cardIcon: cardIcon, cardNumber: value, cardIconName: cardIconName, hasOpacity: !seat.isActive };
            })) || null,
            isActive: seat.status === "FILLED",
        };
    });
    return (_jsx(Container, { children: _jsx(AntTable, { columns: columns, dataSource: dataSource, pagination: false, rowClassName: function (record) { return (record.isActive ? "active-row" : "inactive-row"); } }) }));
};
export default OnlinePlayersInfoCard;
